export const analyticsEvents = [
  "cta_click",
  "offer_form_submit",
  "offer_form_error",
  "checkout_click",
  "purchase",
  "booking_click",
  "booking_fallback_click",
  "scan_option_select",
  "package_select",
  "faq_open",
  "lead",
  "outbound_click",
] as const;

export type AnalyticsEvent = (typeof analyticsEvents)[number];

export type AnalyticsParams = Record<string, string | number | boolean | undefined>;

const BLOCKED_PARAM_KEYS = new Set([
  "email",
  "name",
  "phone",
  "message",
  "repourl",
  "repo_url",
  "company",
]);

type DataLayerPayload = Record<string, string | number | boolean> & { event: AnalyticsEvent };

/**
 * Push a GTM event. No-op on the server. Cookiebot Consent Mode gates the GA4
 * tags, so the push itself does not send a hit before consent.
 * Never include a name, email, phone number, or message text.
 */
export function track(event: AnalyticsEvent, params: AnalyticsParams = {}) {
  if (typeof window === "undefined") return;

  const payload: DataLayerPayload = { event };
  for (const [key, value] of Object.entries(params)) {
    if (value === undefined) continue;
    if (BLOCKED_PARAM_KEYS.has(key.toLowerCase())) continue;
    payload[key] = value;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(payload);
}
